import { CtaCard } from '@uc/web/shared/clearing-ui';

export const META_DATA = {
	title: 'Uni Compare | University Degree Course Search: UK Rankings',
	description:
		'Compare universities, courses, student reviews, read personal statement examples, see university rankings and more. See which uni is near you with our university course search.',
};

export const ENGAGE_DATA: CtaCard[] = [
	{
		title: 'Request info from universities',
		desc: "Got a question for a uni? Submit your questions and get the answers you're looking for, directly from the uni.",
		image: '/assets/img/Request_Info_Search_Image_CTA_Web_02.png',
		link: '/request/select',
		external: false,
	},
	{
		title: 'Bulk order prospectuses',
		desc: 'Learn more about what each uni has to offer and order your FREE prospectus.',
		image: '/assets/img/Order_Prospectus_Search_Image_CTA_Web_02.png',
		link: '/select',
		external: false,
		params: { uni: 'bulk' },
	},
];
